import styled, { AnyStyledComponent } from 'styled-components';
import { LinkColors, LinkProps, LinkDecorationTypes } from './link.types';
import { MLBTheme } from '../../style/theme.types';

const { DOTTED } = LinkDecorationTypes;

const retrieveColorTheme = (theme: MLBTheme | undefined, type: string | undefined, prop: string): string => {
    const dark = (theme && theme.dark) || false;
    const colorTheme: string = dark ? 'dark' : (type || 'primary');
    return LinkColors[colorTheme][prop];
}

export const AnchorElement: AnyStyledComponent = styled.a`
    color: ${ (props: LinkProps) => retrieveColorTheme(props.theme, props.type, 'base') };
    text-decoration: ${ (props: LinkProps) => !(props.decoration === DOTTED) ? props.decoration : 'none' };
    border-bottom: ${ (props: LinkProps) => (props.decoration === DOTTED) ? '1px dotted ' + retrieveColorTheme(props.theme, props.type, 'base') : 'none' };
    font-family: ${(props : LinkProps) => props.theme?.fonts?.family?.primary};

    &:hover {
        border-bottom: ${ (props: LinkProps) => (props.decoration === DOTTED) ? '1px dotted ' + retrieveColorTheme(props.theme, props.type, 'hover') : 'none' };
        color: ${ (props: LinkProps) => retrieveColorTheme(props.theme, props.type, 'hover') };
    }
`;
